var map = {
	"./de/btn-info.png": "1Qao",
	"./en/btn-info.png": "jcR2",
	"./es/btn-info.png": "H5JO",
	"./fr/btn-info.png": "QbV5",
	"./ja/btn-info.png": "Secs",
	"./ko/btn-info.png": "kM5V",
	"./pt/btn-info.png": "RfNr",
	"./ru/btn-info.png": "bw5C",
	"./th/btn-info.png": "ZJHS",
	"./zh-Hant/btn-info.png": "Fynb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6v+i";